import { PROCESS, IMAGES } from "../../lib/data";
import { Reveal, Overline } from "./Reveal";

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <div className="relative">
          <img
            src={IMAGES.therapyStable}
            alt="Therapist assessing a horse in a stable"
            className="w-full h-[520px] object-cover rounded-[2rem] shadow-lg"
          />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Overline>How it works</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight text-charcoal leading-tight">
            Three simple steps to a happier horse
          </h2>
        </Reveal>
        <div className="mt-12 space-y-10">
          {PROCESS.map((p, i) => (
            <Reveal key={p.step} delay={i * 0.1}>
              <div data-testid={`process-step-${i}`} className="flex gap-6">
                <span className="font-heading text-4xl text-clay/40 leading-none w-14 shrink-0">{p.step}</span>
                <div>
                  <h3 className="font-heading text-2xl text-charcoal">{p.title}</h3>
                  <p className="mt-2 text-stone font-light leading-relaxed">{p.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
